import React from 'react';
import { Plane, BrainCircuit, Coins } from 'lucide-react';
import { howItWorksSteps } from '../data/mock';

const iconMap = {
  'plane': Plane,
  'brain-circuit': BrainCircuit,
  'coins': Coins,
};

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="bg-white" style={{ paddingTop: '80px', paddingBottom: '80px' }}>
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 leading-tight mx-auto"
            style={{ 
              maxWidth: '20ch',
              textWrap: 'balance',
              WebkitTextWrap: 'balance'
            }}
          >
            How It Works
          </h2>
          <p 
            className="text-lg sm:text-xl text-gray-600 mx-auto leading-relaxed"
            style={{ 
              maxWidth: '48ch',
              textWrap: 'balance',
              WebkitTextWrap: 'balance'
            }}
          >
            Three simple steps to get your compensation
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {howItWorksSteps.map((step) => {
            const Icon = iconMap[step.icon];
            return (
              <div 
                key={step.step} 
                className="relative bg-gradient-to-br from-blue-50 to-white rounded-2xl p-8 border border-gray-100 hover:border-blue-200 transition-all duration-300 group hover:shadow-lg"
                style={{
                  transform: 'perspective(1000px) rotateX(0deg)',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'perspective(1000px) rotateX(2deg) translateY(-4px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'perspective(1000px) rotateX(0deg) translateY(0)';
                }}
              >
                {/* Step Number Badge */}
                <div className="absolute -top-3 -right-3 w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold text-sm shadow-md">
                  {step.step}
                </div>

                {/* Icon */}
                <div className="flex justify-center mb-5">
                  <div className="w-14 h-14 bg-blue-600 rounded-xl flex items-center justify-center transform group-hover:scale-110 transition-transform duration-300">
                    <Icon className="w-7 h-7 text-white" />
                  </div>
                </div>

                {/* Content */}
                <h3 
                  className="text-lg font-bold text-gray-900 mb-3 text-center"
                  style={{ 
                    textWrap: 'balance',
                    WebkitTextWrap: 'balance'
                  }}
                >
                  {step.title}
                </h3>
                <p 
                  className="text-gray-600 leading-relaxed text-center text-sm"
                  style={{ 
                    textWrap: 'balance',
                    WebkitTextWrap: 'balance'
                  }}
                >
                  {step.description}
                </p>
              </div>
            );
          })}
        </div>

        <div className="mt-10 text-center">
          <p className="text-base text-gray-700 font-medium">
            Average processing time: <span className="text-blue-600 font-bold whitespace-nowrap">4-8 weeks</span>
          </p>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
